import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'postal-codes' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
